<template>
  <div style="background: #FFFFFF;">
    <div class="app-body-1160px">
      <!-- 标题 -->
      <div id="app-brief-introduction-title">
        <h1 style="font-weight: normal;">久仰，在此为开源世界干杯！</h1>
        <div id="app-brief-introduction-title-btn"></div>
      </div>
      <!-- 主体 -->
      <div id="app-brief-introduction-content">
        <!-- 卡片 -->
        <div id="app-brief-introduction-content-card-body">
          <ul>
            <li style="float:left;" v-for="item in card" :key="item.id">
              <el-card class="app-brief-introduction-content-card">
                <img alt="pic" :src="item.img" class="app-brief-introduction-content-card-icon"/>
                <span class="app-brief-introduction-content-card-p">{{ item.text }}</span>
              </el-card>
            </li>
          </ul>
          <div style="clear: both"></div>
        </div>
        <!-- 底部文字 -->
        <p id="app-brief-introduction-content-p">
          HI伙伴，改变世界需要知识和勇气，而我们的勇气是尽可能的为所有人提供研究和探索的经验如你所见，这里还有那里的东西都可以统统直接拿走~
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BriefIntroduction",
  data() {
    return {
      card: [
        {
          img: 'https://img.blendermagic.cn/new/icon/Curriculum.png',
          text: '开源课程',
        },
        {
          img: 'https://img.blendermagic.cn/new/icon/Everything.png',
          text: '万物有灵',
        },
        {
          img: 'https://img.blendermagic.cn/new/icon/Assets.png',
          text: '开源资产',
        },
        {
          img: 'https://img.blendermagic.cn/new/icon/BLT.png',
          text: 'BLT',
        },
        {
          img: 'https://img.blendermagic.cn/new/icon/Communication.png',
          text: '交流小组',
        },
      ]
    }
  }
}
</script>

<style scoped>

#app-brief-introduction-title {
  width: 450px;
  margin: auto;
  padding-top: 50px;
}

#app-brief-introduction-title-btn {
  width: 100px;
  border-bottom: 3px solid #FF8A00;
  margin: 30px auto auto;
}

#app-brief-introduction-content-card-body {
  width: 750px;
  margin: 30px auto;
}

.app-brief-introduction-content-card {
  position: relative;
  width: 120px;
  height: 50px;
  margin-left: 25px;
  line-height: 50px;
  font-size: 20px;
}

.app-brief-introduction-content-card-icon {
  position: absolute;
  left: 5px;
  top: 10px;
  height: 30px;
  width: 30px;
  padding-right: 10px;
}

.app-brief-introduction-content-card-p {
  font-size: 17px;
  margin-left: 30px;
}

#app-brief-introduction-content-p {
  width: 650px;
  margin: auto;
  padding-bottom: 40px;
  line-height: 30px;
  color: #6d6d6d;
}

</style>